import { gql } from '@apollo/client'
import { userConsentFragment } from '~/graphql/fragments/consents'

export const GIVE_USER_CONSENT = gql`
  mutation giveConsent($input: GiveConsentInput!) {
    giveConsent(input: $input) {
      consents {
        ...userConsent
      }
      errors {
        code
        message
      }
    }
  }

  ${userConsentFragment}
`
